import React, { useEffect, useState, useCallback } from 'react';
import IconPlay from '../assets/img/icon_play.svg';
import useGame from '../hooks/useGame';
import { useTranslation } from 'react-i18next';

const CorrectAnswer = ({ question, isPlaying, scoreTier }) => {

  const { t } = useTranslation();
  const [seconds, setSeconds] = useState(5);
  const [paused, setPaused] = useState(false);
  const { nextQuestion, language } = useGame();

  const generateRandomNumber = (max) => {
    return Math.floor(Math.random() * (max - 1 + 1) + 1);
  };

  const [text, setText] = useState('');

  useEffect(() => {
    let max = 4;
    // if (scoreTier === 1 && language !== 'et') {
    //   max = 4;
    // }
    // if (scoreTier === 2) {
    //   max = 4;
    // }
    // if (scoreTier === 3 && (language === 'lv' || language === 'ru')) {
    //   max = 4;
    // }
    // if (scoreTier === 4 && language === 'lv') {
    //   max = 4;
    // }
    //
    // if (language === 'lt' && (scoreTier === 3 || scoreTier === 4)) {
    //   max = 2;
    // }

    const rand = generateRandomNumber(max);
    let index = scoreTier;
    if (index > 4) {
      index = 4;
    }

    // console.log('st', index);
    setText(t(`correct.phrases.${index}.${rand}`));
  }, [scoreTier, language]);


  const toggle = useCallback((evt) => {
    if (evt.type === 'click' || evt?.keyCode === 13 || evt?.keyCode === 32) {
      setPaused(!paused);
    }
  }, [paused, setPaused]);

  const removeBodyClass = className => document.body.classList.remove(className);

  useEffect(() => {
    const interval = setInterval(() => {
      if (isPlaying && seconds > 0 && !paused) {
        setSeconds(seconds => seconds - 1);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [seconds, isPlaying, paused]);

  useEffect(() => {
    if (seconds < 1) {
      removeBodyClass('fade-in-correct');
      removeBodyClass('fade-in-question');
      removeBodyClass('fade-out-video');
      nextQuestion();
    }
  }, [seconds, nextQuestion]);

  return (
    <section className="correct-screen fade-in-correct">
      <div className="inner">
        <h1>{text}</h1>
        <div className="q-count">
          <span className="done-count">{question}</span>
          <span className="split">/</span>
          <span className="to-go">10</span>
        </div>
      </div>
      {question !== 10 && (
        <div className="pause">

          {!paused && (
            <span className="icon pause-next" onClick={toggle} />
          )}
          {paused && (
            <img src={IconPlay} width="12" height="20" onClick={toggle} alt="" />
          )}

          <p>
            <span tabIndex={0} className="next-question" role='button'
              onClick={(evt) => toggle(evt)}
              onKeyDown={(evt) => toggle(evt)}
            >{t('correct.next_question')}</span>
            <span className="count-down" id="count-down" 
            >
              <span>00</span>
              <span>:</span>
              <span>0<span id="sec-count" key={new Date()}>{seconds}</span></span>
          </span>
          </p>
        </div>
      )}
    </section>
  );
};

export default CorrectAnswer;
